export const selectorLogin = state => state.login;

export const existeixUsuariRegistrat = state => {
    const dadesLogin = selectorLogin(state);
    return Object.keys(dadesLogin).length > 0;
};



// WEBPACK FOOTER //
// ./src/selectors/selector_login.js